// Public work descriptions confirmed by the founders. Shared across audiences.
export const COMPANY_WORK = [
  { id: 'ginkgo', name: 'Ginkgo', work: 'Partnered to deploy an intent layer on its cloud lab.' },
  { id: 'taudia', name: 'Taudia', work: 'Automated liquid handling for antibody-pair screening.', source: 'https://www.linkedin.com/posts/labautomation-antibodydiscovery-rnd-share-7496374601124335617-7uxS/' },
  { id: 'stealth', name: 'Stealth biotech', work: 'Brought legacy systems back into use.' },
];

// Keep destination names and routes consistent in navigation and body links.
export const SCIENCE_LINKS = {
  overview: { to: '/scientists', label: 'For scientists' },
  solutions: { to: '/scientists/solutions', label: 'Solutions' },
  workingTogether: { to: '/scientists/working-together', label: 'Working together' },
  engagements: { to: '/scientists/engagements', label: 'Engagement options' },
  evaluation: { to: '/scientists/evaluation', label: 'How we test' },
  openProblems: { to: '/scientists/open-problems', label: 'Open problems' },
  fieldNotes: { to: '/scientists/field-notes', label: 'Field notes' },
  agents: { to: '/scientists#research-team', label: 'Meet the agents' },
  integrations: { to: '/scientists#integrations', label: 'Explore integrations' },
  benchmarks: { to: '/scientists#scientific-evidence', label: 'Scientific benchmarks' },
  contact: { to: '/scientists/contact', label: 'Discuss a project' },
};

export const SOLUTION_AREAS = [
  { id: 'lab-automation', title: 'Lab automation', href: '/scientists/solutions#lab-automation' },
  { id: 'scientific-data', title: 'Scientific data', href: '/scientists/solutions#scientific-data' },
  // Retain the existing anchor for bookmarks and shared links.
  { id: 'specialized-ai', title: 'Scientific AI', href: '/scientists/solutions#specialized-ai' },
];

export const INVESTOR_LINKS = {
  vision: { to: '/investors#vision', label: 'Our vision' },
  work: { to: '/investors#why-now', label: 'Our work' },
  development: { to: '/investors#inside-the-lab', label: 'Drug development' },
  research: { to: '/investors#our-team', label: 'People' },
  contact: { to: '/investors/contact', label: 'Get in touch' },
};

export const DISCOVERY_LINK = { href: 'https://discovery.cornucopiabio.com', label: 'Explore Discovery' };

export const PUBLIC_WORK_ARTIFACT = { href: 'https://kiteml.com/blog/open-source-bio-lab', label: 'Inside our open-source robotics project with Kite ML' };
